import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, shallowRef } from "vue";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_PROJECT_CLONE } from "@/configs/Apis";
import { showSuccess } from "@/utils/UI";
import { isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCopyDialog',
  emits: ["saved"],
  setup(__props, { expose, emit }) {



const visible = ref(false);
const form = shallowRef<any>(null);

const postedData = reactive({
  id: "",
  name: "",
  remark: "",
  clonePatent: false,
  cloneCategory: true,
  cloneCustomizedField: true,
  cloneFilter: true,
  cloneListLayout: true,
  cloneReport: true,
});

const defaultCloneData = {
  id: "",
  name: "",
  remark: "",
  clonePatent: false,
  cloneCategory: true,
  cloneCustomizedField: true,
  cloneFilter: true,
  cloneListLayout: true,
  cloneReport: true,
};

const rules = computed(() => ({
  name: [{ required: true, message: "请输入数据库名称", trigger: "blur" }],
}));

const open = (initData: any = null) => {
  Object.assign(postedData, defaultCloneData);
  if (!isEmpty(initData)) {
    Object.assign(postedData, {
      id: (initData as any).id,
      name: (initData as any).name + "[复制]",
      remark: (initData as any).remark,
    });
  }
  visible.value = true;
};

const save = async () => {
  const isValid = await form.value.validate().catch(() => false);
  if (!isValid) {
    return;
  }
  const postedRequestData: any = {
    name: postedData.name,
    remark: postedData.remark,
    clonePatent: postedData.clonePatent,
    cloneCategory: postedData.cloneCategory,
    cloneCustomizedField: postedData.cloneCustomizedField,
    cloneFilter: postedData.cloneFilter,
    cloneListLayout: postedData.cloneListLayout,
    cloneReport: postedData.cloneReport,
  };
  if (!isEmptyOrWhiteSpace(postedData.id)) {
    postedRequestData.id = postedData.id;
  }
  await DuduAjax.post(API_BIS_PROJECT_CLONE, postedRequestData);
  showSuccess("复制成功");
  visible.value = false;
  emit("saved");
};

expose({ open });

return { __sfc: true,emit, visible, form, postedData, defaultCloneData, rules, open, save }
}

})